import { bucketSize } from './bucketSize';
import { clips } from './clips';
import { contentDestinations } from './content-destinations';
import { feeds } from './feeds';
import { media } from './media';
import { playlists } from './playlists';
import { sites } from './sites';

export const v1 = {
  bucketSize,
  clips,
  contentDestinations,
  feeds,
  media,
  playlists,
  sites,
};
